import {Usage} from '../common/UsageSchema';
import {ScannedVIN} from './ScannedVIN';

export type ScanVINUseCaseResult = {
  result: ScannedVIN;
  usage: Usage;
};
